import surveyDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const surveyReducer = surveyDispatcher(initialState, {
  [surveyDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [surveyDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  })
});

export default surveyReducer;
